import { useEffect, useState } from 'react'
import { AppState, AppStateStatus } from 'react-native'

const useAppState = () => {
  const [state, setState] = useState<AppStateStatus>(AppState.currentState)

  useEffect(() => {
    const listener = AppState.addEventListener('change', setState)

    return () => listener.remove()
  }, [])

  return state
}

export default useAppState
